/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugExportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param drugId
     * @param registerId
     * @returns any Success
     * @throws ApiError
     */
    public getApiDrugExportExport(
        drugId?: string,
        registerId?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugExport/Export',
            query: {
                'DrugId': drugId,
                'RegisterId': registerId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
